import { CPT_CODES } from "constants/cptCodes";

export function ClientServicesForClipboard({
  noteCodes,
}: {
  noteCodes: NoteCodes;
}) {
  return (
    <div>
      <h2>Client Services</h2>
      <div>CPT/Service Code</div>
      <ul>
        {noteCodes.service_codes?.map((serviceCode) => (
          <li key={serviceCode}>
            {serviceCode} -{" "}
            {CPT_CODES.find((el) => el.id === serviceCode)?.description}
          </li>
        ))}
      </ul>
    </div>
  );
}
